module.exports = __webpack_public_path__ + "static/join-bg-1512c6ca07536d09a4f4c2c9bb30b441.jpg";